// TotalsDisplay.js
import { formatCurrency } from "../../Help/helper";


export const TotalsDisplay = ({ totals, includeTax, setIncludeTax, taxOnServicesOnly, setTaxOnServicesOnly, finalizeQuotation }) => {


  return (
    <>


<div className="sticky top-4 p-4 bg-gray-50 rounded shadow">
                                  <div className="flex items-center justify-between mb-4">

                                    <button onClick={finalizeQuotation} className="bg-blue-600 hover:bg-green-700 text-sm text-white py-2 px-2 rounded transition duration-200">
                                      Finalize Quotation
                                    </button>
                                  </div>
                                  <div className="mb-4">
                                    <label className="flex items-center space-x-3 mb-3">
                                      <input
                                        type="checkbox"
                                        checked={includeTax}
                                        onChange={(e) => setIncludeTax(e.target.checked)}
                                        className="form-checkbox h-5 w-5 text-blue-600"
                                      />
                                      <span className="text-sm text-gray-700 font-semibold">Include 7.5% VAT</span>
                                    </label>

                                    {includeTax && (
                                      <div className="ml-6 mb-3 space-y-2">
                                        <label className="flex items-center space-x-2">
                                          <input
                                            type="radio"
                                            name="taxOption"
                                            checked={!taxOnServicesOnly}
                                            onChange={() => setTaxOnServicesOnly(false)}
                                            className="form-radio h-4 w-4 text-blue-600"
                                          />
                                          <span className="text-xs text-gray-600">Apply VAT on all items</span>
                                        </label>
                                        <label className="flex items-center space-x-2">
                                          <input
                                            type="radio"
                                            name="taxOption"
                                            checked={taxOnServicesOnly}
                                            onChange={() => setTaxOnServicesOnly(true)}
                                            className="form-radio h-4 w-4 text-blue-600"
                                          />
                                          <span className="text-xs text-gray-600">Apply VAT on services/labour only</span>
                                        </label>
                                      </div>
                                    )}

                                    <div className="text-sm border-t pt-3">
                                      <p className="mb-1">SUBTOTAL: {formatCurrency(totals.subtotal)}</p>
                                      {taxOnServicesOnly && includeTax && (
                                        <p className="text-xs text-gray-500 mb-1">Services Subtotal: {formatCurrency(totals.servicesSubtotal || 0)}</p>
                                      )}
                                      <p className="mb-2">VAT (7.5%): {includeTax ? formatCurrency(totals.taxAmount) : "₦0.00"}</p>
                                      <p className="font-bold text-xl">TOTAL: {formatCurrency(totals.totalSale)}</p>
                                    </div>
                                  </div>
                                 </div>


    </>
  )

  };